import type LoggerService from './logger.service';

function serializeUnknown(value: unknown, nullFallback = 'N/A'): string {
  if (value === null || value === undefined) return nullFallback;
  if (value instanceof Error) return value.stack ?? value.message;
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

export default function initializeGlobalErrorHandler(app: angular.IModule) {
  app.factory('$exceptionHandler', [
    'loggerService',
    function (loggerService: LoggerService) {
      return function (exception: any, cause?: any): void {
        loggerService.error('Unhandled AngularJS Error', {
          exception: serializeUnknown(exception),
          cause: serializeUnknown(cause)
        });
      };
    }
  ]);

  app.run([
    'loggerService',
    function (loggerService: LoggerService) {
      window.addEventListener('error', (event: ErrorEvent) => {
        loggerService.error('Global JS Error', {
          exception: event.error ? (event.error.stack ?? event.error.message) : event.message,
          source: event.filename,
          lineno: event.lineno,
          colno: event.colno
        });
      });

      window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        loggerService.error('Unhandled Promise Rejection', {
          exception: serializeUnknown(event.reason, 'Unknown rejection reason')
        });
      });
    }
  ]);
}
